import { useInfiniteQuery } from '@tanstack/react-query';

import { getNextPageParam, useNFTMainOwnerData } from '@pkg/hooks';

import { callGetUserAssets } from '@app/client/resources/yat-pages/page-items';
import { type FilterType } from '@app/pages/NFTDetailView/components/OwnerPanel/OwnerContent/CardFilters/types';

export type GetOwnerAssetsProps = {
    filter: FilterType;
    enabled?: boolean;
};
export const useGetOwnerAssets = ({ filter, enabled = true }: GetOwnerAssetsProps) => {
    const { owner } = useNFTMainOwnerData();
    const ownerId = owner?.id || '';
    const cache = ['ownerAssets', ownerId, filter];

    const queryParams =
        filter === 'valuable'
            ? {}
            : {
                  purchased: true,
                  transferred: true,
                  sold: true,
              };

    const filterParam = filter === 'valuable' ? 'most_valuable' : 'recent_items';

    return useInfiniteQuery(
        cache,
        ({ signal, pageParam = 0 }) =>
            callGetUserAssets({
                ownerId,
                filter: filterParam,
                query: { limit: 10, spam: false, page: pageParam || 0, ...queryParams },
                settings: {
                    signal,
                },
            }),
        {
            retry: false,
            enabled: Boolean(ownerId && filter && enabled),
            getNextPageParam,
        },
    );
};
